import {canonicalMerge,mergeHash,buildMergeProposal,verifyProposalReceipt,verifyAutomaticReceipt,verifyPreparedMergeBase} from './visitaMergeJournal.js';

export const VISITA_MERGE_BASE_ACKNOWLEDGED='visita:merge-base-acknowledged';
const clone=value=>JSON.parse(JSON.stringify(value));
const maps=['responses','custom_subgroup_names','instance_states'];
const scalars=['observacion','estado_sistema'];
const structural=['dynamic_group_items','instance_owners','excluded_from_report_fields','excluded_subgroup_instances',
    'excluded_manual','excluded_auto','hidden_response_fields','imagenes','adjuntos_documentacion'];
const same=(a,b)=>canonicalMerge(a)===canonicalMerge(b);

// Trasladar sólo la intención posterior a N. Si el efecto de N incorporó un
// cambio ajeno sobre ese mismo campo, no convertirlo en un acuerdo ficticio.
export function carryCausalMergeIntent(sent,local,applied){
    if(structural.some(key=>!same(sent[key],local[key])))return null;
    const next=clone(local);
    for(const name of maps){
        const before=sent[name]||{},current=local[name]||{},server=applied[name]||{};
        next[name]=clone(server);
        for(const key of new Set([...Object.keys(before),...Object.keys(current)])){
            if(same(before[key],current[key])&&Object.hasOwn(before,key)===Object.hasOwn(current,key))continue;
            if(!same(server[key],before[key])&&!same(server[key],current[key]))return null;
            if(Object.hasOwn(current,key))next[name][key]=clone(current[key]);else delete next[name][key];
        }
    }
    for(const name of scalars){
        if(!same(sent[name],local[name])&&!same(applied[name],sent[name])&&!same(applied[name],local[name]))return null;
        next[name]=same(sent[name],local[name])?applied[name]??null:local[name]??null;
    }
    return next;
}

export async function reconcileCausalMergeAck({sentRow,context,automatic,driver,stores,readEntry,withLock,isCurrent,onBase=async()=>{},
    uuid=()=>crypto.randomUUID(),now=()=>new Date().toISOString()}){
    const current=()=>{if(!isCurrent())throw Error('Cambió la cuenta; se conserva la edición.');};
    current();verifyProposalReceipt(sentRow.receipt,sentRow);verifyAutomaticReceipt(automatic,sentRow);
    if(!automatic.complete)return {eligible:false};
    const sent=sentRow.original,originalPrepared=sent?.payload?._merge;
    if(!sent||sent.revisionId!==sentRow.revisionId||sent.userId!==sentRow.userId||sent.visitaId!==sentRow.visitaId
        ||sentRow.bodyHash!==await mergeHash(sentRow.literal)
        ||buildMergeProposal(sent,originalPrepared,sentRow.revisionId,JSON.parse(sentRow.literal).origin)!==sentRow.literal)
        throw Error('El original causal no conserva su revisión y cuerpo exactos.');
    const prepared=automatic.applied_base||context?.offline_merge_base;
    await verifyPreparedMergeBase(prepared,{userId:sentRow.userId,empresaId:sentRow.empresaId,visitaId:sentRow.visitaId});
    const before=JSON.parse(originalPrepared.base.canonical_payload),after=JSON.parse(prepared.base.canonical_payload);
    if(after.responses_version!==automatic.responses_version||prepared.base.snapshot_hash!==automatic.after_snapshot_hash)
        return {eligible:false,reason:'exact_version_missing'};
    if(!same(before.instances,after.instances)||!same(before.field_bindings,after.field_bindings)||before.form_revision!==after.form_revision)
        return {eligible:false,reason:'structure_changed'};
    const baseline={...clone(sent.payload),...clone(after.snapshot)};delete baseline._merge;delete baseline._local_first;
    const result=await withLock(async()=>{
        current();const original=await readEntry();current();
        if(!original)return {eligible:true,pending:false};
        if(original.userId!==sent.userId||original.visitaId!==sent.visitaId||!original.payload?._merge)return {eligible:false};
        if(original.revisionId===sent.revisionId)return {eligible:false}; // Sólo su recibo exacto puede retirarla.
        if(original.payload._merge.base.payload_hash===prepared.base.payload_hash)return {eligible:true,pending:true,entry:original};
        if(original.payload._merge.base.payload_hash!==originalPrepared.base.payload_hash)return {eligible:false,reason:'another_base'};
        const payload=carryCausalMergeIntent(sent.payload,original.payload,baseline);
        if(!payload)return {eligible:false,reason:'concurrent_field_or_structure'};
        const archiveId=`merge-rebase-original:${sentRow.empresaId}:${sent.userId}:${sent.visitaId}:${original.revisionId}`;
        const archive={id:archiveId,kind:'merge_rebase_original',userId:sent.userId,empresaId:sentRow.empresaId,visitaId:sent.visitaId,
            scope:sentRow.scope,templateVersion:after.form_revision,version:uuid(),original:clone(original),savedAt:now(),
            cause:{revisionId:sent.revisionId,applicationUuid:automatic.application_uuid,bodyHash:automatic.body_hash,afterSnapshotHash:automatic.after_snapshot_hash}};
        await driver.mutate(stores.CONTEXTS,archiveId,existing=>{
            current();if(existing&&!same(existing.original,original))throw Error('No se sobrescribe otro original conservado.');return existing||archive;
        });
        if(!same((await driver.get(stores.CONTEXTS,archiveId))?.original,original))throw Error('No se confirmó el respaldo de la edición posterior.');
        current();const revisionId=uuid(),updatedAt=now();
        const next={...clone(original),revisionId,updatedAt,payload:{...payload,_merge:clone(prepared),_local_first:{base:clone(baseline)}},
            ...(Object.hasOwn(original,'revision_id')?{revision_id:revisionId}:{}),...(Object.hasOwn(original,'updated_at')?{updated_at:updatedAt}:{})};
        await driver.mutate(stores.ENTRIES,original.key,existing=>{current();return same(existing,original)?next:existing;});
        current();const saved=await readEntry();if(!same(saved,next))return {eligible:false,reason:'newer_edit',preserved:true};
        return {eligible:true,pending:true,entry:saved,rebased:true};
    });
    if(result.eligible){current();await onBase({prepared,sent:clone(sent.payload),applied:baseline,automatic,pending:result.pending});}
    return result;
}
